import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vat'
})
export class VatPipe implements PipeTransform {

  constructor() {
  }

  transform(price: any, ...args: any[]): any {
    const [ vat ] = args;
    return (price * (vat / 100)) / (1 + (vat / 100));
  }
}
